import type { EraId } from '../config/eras';

/**
 * A day a car was rebuilt: what changed, told once (per device) to players who have raced before, as their
 * first race of that day is about to set off (the car waits for "got it"). New players get the lesson instead.
 */
export interface CarNote {
  /** Remembered once read (gp.carNote.<id>). */
  id: string;
  era: EraId;
  title: string;
  body: string;
  /** What to do about it, in a few words. */
  tip: string;
}

export const CAR_NOTES: Record<string, CarNote> = {
  // Handling 3.4: the 2004 rebuilt like the 2022, during the race.
  '2026-10-12': {
    id: '2004-grip',
    era: '2004',
    title: 'new brakes on the 2004',
    body: 'We noticed sliding helped too much: throwing the car sideways was the quickest way round. From today it brakes much harder, and a slide costs time. We deleted the times set with the old car, so everyone races the same one.',
    tip: 'brake later · turn in clean',
  },
};

export function carNote(date: string, era: EraId): CarNote | null {
  const n = CAR_NOTES[date];
  return n && n.era === era ? n : null;
}
